import ApiRouteProvider from '../route'
import axios from '@axios'

export default {
    getChatByRequestId(id) {
        return axios.get(ApiRouteProvider.messenger.getChatByRequestId(id));
    },

    sendMessage(chatId, message) {
        return axios.post(ApiRouteProvider.messenger.sendMessage(chatId), {
            message: message
        });
    },

    getUnreadMessages(chatId, offset) {
        return axios.get(ApiRouteProvider.messenger.unreadMessages(chatId, offset));
    }
};
